import React from "react";
import RBModal from "react-bootstrap/esm/Modal";
import PositionEnum from "../../enums/position.enum";
import SizeExtraEnum from "../../enums/size-extra.enum";
import classMap from "../../helpers/classMap";
import ModalProps from "./modal.props";
import "./modal.scss";

const Modal = (props: ModalProps) => {
  const fullscreen: boolean = props.size === SizeExtraEnum.FULL;
  const showClose: boolean = props.showClose ?? true;
  const hideBorders: string = props.hideBorders ? "border-0" : "";
  const idModal: string = props.id || `mpng-ux-modal-default-${Date.now()}`;
  const idTitle: string = `${idModal}-dialog-title`;

  return (
    <RBModal
      {...{
        id: idModal,
        className: classMap("mpng-ux-modal ", props.className),
        show: props.showModal,
        onHide: props.handleClose,
        backdrop: fullscreen ? false : props.backdrop ?? true,
        size: props.size !== "full" && props.size !== "md" ? props.size : undefined,
        centered: props.vPosition === PositionEnum.CENTER,
        dialogClassName: classMap(
          fullscreen ? "mw-100 mh-100 h-100 m-0" : undefined,
          props.hideBorders ? "hide-borders" : "",
          props.hideContainer ? "hide-container" : ""
        ),
        animation: props.animation || true,
        scrollable: props.scrollable || false,
        backdropClassName: props.backdropClassName,
        contentClassName: classMap("mpng-ux-modal-content ", props.contentClassName),
        onEscapeKeyDown: props.handleClose
      }}
      aria-labelledby={`${idModal}-title`}
    >
      {(props.title || showClose) && (
        <RBModal.Header className={classMap(props.headerClassName, hideBorders)} closeButton={showClose}>
          <RBModal.Title className="w-100" id={idTitle}>
            {props.title}
          </RBModal.Title>
        </RBModal.Header>
      )}
      <div role="main">
        <RBModal.Body className={classMap("h-100 mh-100", props.bodyClassName)}>{props.body}</RBModal.Body>
      </div>
      {props.footer && (
        <RBModal.Footer className={classMap(hideBorders, props.footerClassName)}>
          {props.footer.map((child: any, key: number) => (
            <div key={child.id ?? key}>{child}</div>
          ))}
        </RBModal.Footer>
      )}
    </RBModal>
  );
};

export default Modal;
